/*    
<summary>
   This file is used to provide initial values or state to the User Data observables.
   Developer:Ashish Singh, Created Date: 29-August-2023
</summary>
*/

import { IAddProductManagement } from "../../models/forms/IAddProduct";


export const initialState:IAddProductManagement = {
  RegistrationType: 0,
  BusinessTypeId: -1,
  CategoryId: -1,
  CategoryPath: "",
  ProductName: '',
  PriceExcludingTax: "",
  PriceIncludingTax: "",
  TaxId: -1,
  TaxValue: 0,
  TaxAmount: "",
  BarCode: '',
  ProductCategory: "0",
  Status: '0',
  StartDate: "",
  EndDate: "",
  Image: "",
  Note: "",
  Description: '',
  StoreId: null,
  UnitPrice: '',
  UnitPriceExcludingTax: "",
  UnitPriceTaxAmount: "",
  UnitPriceTaxId: -1,
  UnitPriceTaxValue: 0,
  IsAutoCalculateTax: true
}